import {ICONS} from '@/constants/icons';

export default {
  updatedAtLabel: 'Aktualisiert:',
  breadcrumbs: {
    home: 'Startseite',
  },
  hero: {
    badges: [
      {
        iconName: 'badgeTrustUs',
        description: 'Warum Sie uns vertrauen können',
        details: {
          text: '<h2>Warum Sie uns vertrauen können</h2><p>Die Artikel auf Natu.Care werden auf der Grundlage von wissenschaftlichen Untersuchungen, Daten von staatlichen Websites und anderen zuverlässigen Quellen verfasst. Die Texte werden in Zusammenarbeit mit Ärzten, Ernährungswissenschaftlern und anderen Gesundheits- und Schönheitsexperten verfasst. Die Artikel werden vor der Veröffentlichung und bei wichtigen Aktualisierungen überprüft.</p>',
          footerText: '<p>Weitere Informationen finden Sie in unserem <a href="/de/uber-uns/redaktioneller-prozess">der redaktionelle Prozess</a></p>'
        }
      },
      {
        iconName: 'badgeAdDisclosure',
        description: 'Informationen zur Werbung',
        details: {
          text: '<h2>Informationen zur Werbung</h2><p>Der Inhalt von Natu.Care kann Links zu Produkten enthalten, für deren Verkauf wir eine Provision erhalten können. Bei der Erstellung von Inhalten halten wir uns an hohe redaktionelle Standards und achten darauf, dass die von uns besprochenen Produkte objektiv sind. Das Vorhandensein von Affiliate-Links wird nicht von unseren Partnern diktiert, und wir wählen die Produkte, die wir besprechen, völlig unabhängig selbst aus.</p>',
          footerText: '<p>Weitere Informationen finden Sie in unserem <a href="/de/vorschriften">Vorschriften</a></p>'
        }
      }
    ],
    tooltip: {
      labelVerified: 'Von einem Sachverständigen geprüft',
      footerText: '<p>Erfahren Sie mehr über unser <a href="/de/uber-uns/redaktioneller-prozess">der redaktionelle Prozess</a></p>'
    }
  },

  mediabar: {
    heading: 'Die Medien über uns:',
    href: '/de/uber-uns',
    title: 'Über uns',
    items: [
      {
        icon: ICONS['vogue'],
        href: 'https://kobieta.wp.pl/toner-do-wlosow-jak-nakladac-6861428991200064a'
      },
      {
        icon: ICONS['wpKobieta'],
        href: 'https://zdrowietvn.pl/a/poznaj-zrodla-kolagenu-i-badz-piekna'
      },
      {
        icon: ICONS['medonet'],
        href: 'https://porady.interia.pl/artykul-sponsorowany/news-poznaj-dzialanie-tonera-do-wlosow,nId,6525474'
      },
      {
        icon: ICONS['zdrowieTvn'],
        href: 'https://zwierciadlo.pl/material-partnera/532112,1,toner-do-wlosow--jak-nakladac.read'
      },
      {
        icon: ICONS['interiaPorady'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['zwierciadlo'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      },
      {
        icon: ICONS['uPacjenta'],
        href: 'https://upacjenta.pl/poradnik/wplyw-witaminy-d3-na-skore'
      }   
    ]
  },

  cta: {
    heading: 'Für einen gesunden Körper sorgen',
    description: 'Probieren Sie die hochwertigen Nahrungsergänzungsmittel von Natu.Care',
    button: {label: 'Produkte ansehen', href: 'https://natu.shop/collections'},
    picture: {alt: 'Junge, schöne Frauen mit gutem Hautzustand.'}
  },

  authorship: {
    heading: 'Redaktion',
    link: {
      label: 'Treffen Sie das Team',
      href: '/de/uber-uns/redaktion'
    }
  },

  similarArticles: {
    headingBlogList: 'Artikel',
    headingBlogPost: 'Ähnliche Artikel'
  }
};